import { useEffect } from 'react';
import { useHotkeysContext } from 'react-hotkeys-hook';

export const useDisableHotkeys = (disable = true, replaceWithScope?: string) => {
  const { enabledScopes, disableScope, enableScope } = useHotkeysContext();
  useEffect(() => {
    if (!disable) return;
    const scopesToRestore = [...enabledScopes];
    enabledScopes.forEach(disableScope);
    if (replaceWithScope) enableScope(replaceWithScope);
    return () => {
      if (replaceWithScope) disableScope(replaceWithScope);
      scopesToRestore.forEach(enableScope);
    };
  }, [disable]);
};